import sendRequest from "../fetch";
import api from "../url";
import Qs from "qs";
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";

const _base = "examFace/";


// 在线考试 - 考试人脸检查
export const faceIdentify = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "identify", {
           data: params,
           isWarning: false,
           method: "POST",
         });
       };
// 在线考试 - 抓拍
export const faceSnap= (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "snap", {
           data: params,
           method: "POST",
         });
       };

// 在线考试 - 切换屏幕记录
export const switchScreen = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "switchScreen", {
    data: Qs.stringify(_params),
    method: "POST",
  });
};



// WEBPACK FOOTER //
// ./src/fetch/api/faceApi.js